import $ from "jquery";
import videojs from "video.js";
require("!style-loader!css-loader!video.js/dist/video-js.css");

var element = document.getElementById("landing-video");
var $button = $(".block-landing-video-button");

if (element) {
  var options = {
    autoplay: false,
    controls: false,
    loop: false,
    // muted: true,
    fluid: true,
    preload: "auto"
  };

  var player = videojs("landing-video", options, function onPlayerReady() {
    $(".block-landing-video").addClass("show");
    // videojs.log("Your player is ready!");
    var video = this;

    video.on("ended", function() {
      $button.removeClass("playing");
    });

    $button.on("click", function() {
      if (!$(".video-js").hasClass("vjs-playing")) {
        video.play();
        $button.addClass("playing");
        $button.addClass("has-played");
      } else {
        video.pause();
        $button.removeClass("playing");
      }
    });
  });
}
